import { BottomNav } from '../common/BottomNav.js';

export const KanitTemelliScreen = () => {
    return `
        <div id="kanit-temelli-screen" class="screen">
            <!-- Header -->
            <div class="screen-header">
                <button class="back-btn" onclick="window.Router.showScreen('category-screen')">
                    <span class="icon">⬅️</span> GERİ
                </button>
            </div>

            <div class="kanit-main-container">
                <h2 class="kanit-main-title">KANIT TEMELLİ TARİH</h2>
                
                <button class="kanit-book-card" onclick="window.Router.showScreen('etkinlik-kitap-screen')">
                    <div class="kanit-card-decoration top-left"></div>
                    <div class="kanit-card-decoration bottom-right"></div>
                    
                    <span class="kanit-card-icon">🏰</span>
                    <span class="kanit-card-title">Yerleşme ve Devletleşme Sürecinde Selçuklu Türkiyesi</span>
                </button>
            </div>

            ${BottomNav()}
        </div>
    `;
};
